import { Action } from 'components/Controls/Control/actions/type';
import { useCallback } from 'react';
import { useRouter } from 'next/router';
import { useUILanguage } from 'hooks/useUILanguage';
import { getCanonicalBaseURL } from 'utils/url';
import { Language, Service } from '@yleisradio/areena-types';
import { useAreenaService } from 'contexts/AreenaServiceContext';
import { serviceRoutes } from 'utils/routes';

const createTargetUrl = (language: Language, service: Service | undefined) => {
  const targetLanguage: Language = language === 'fi' ? 'sv' : 'fi';
  const targetBaseUrl = getCanonicalBaseURL(targetLanguage);

  if (!service) {
    return targetBaseUrl;
  }
  return `${targetBaseUrl}/${serviceRoutes[service][targetLanguage]}`;
};

export function useSwitchLanguageAction(): Action {
  const router = useRouter();
  const language = useUILanguage();
  const { areenaService } = useAreenaService();
  const targetUrl = createTargetUrl(language, areenaService);

  const runAction = useCallback(() => {
    void router.push(targetUrl);
  }, [router, targetUrl]);

  return {
    runAction,
    executing: false,
  };
}
